import React from 'react'

export const OwsContext = React.createContext({})

export default function OwsContextProvider({ value, children }) {
  return <OwsContext.Provider value={value}>{children}</OwsContext.Provider>
}
